import styled from "styled-components";
import { Layout } from "style/layout";

export default styled(Layout)`
	display: flex;
	flex-direction: column;
`;
